  (function () {
    var formWrapper = document.getElementById('BundleSelector');
    if (!formWrapper) return;

    var qtyInput = formWrapper.querySelector('#BundleQty');
    var countDisplay = formWrapper.querySelector('[data-amount-count]');
    var savingsEl = formWrapper.querySelector('[data-amount-savings]');
    var savingsValueEl = formWrapper.querySelector('[data-amount-savings-value]');
    var atcText = formWrapper.querySelector('[data-bundle-atc-text]');
    var atcBtn = formWrapper.querySelector('[data-bundle-atc]');
    var tierBtns = formWrapper.querySelectorAll('[data-bundle-tier]');
    var decBtn = formWrapper.querySelector('[data-amount-decrement]');
    var incBtn = formWrapper.querySelector('[data-amount-increment]');
    var atcPrefix = formWrapper.dataset.atcPrefix || 'In den Warenkorb legen:';
    var savingsPrefix = formWrapper.dataset.savingsPrefix || 'Spare';
    var moneyFormat = formWrapper.dataset.moneyFormat || '{{amount}}';

    function formatWithDelimiters(cents, precision, thousands, decimal) {
      if (isNaN(cents) || cents === null || cents === undefined) return '0';
      var number = (cents / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return whole + fraction;
    }

    var formatMoney = function (cents) {
      if (cents === null || cents === undefined) return '';
      var format = moneyFormat;
      var value;
      if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
        value = formatWithDelimiters(cents, 0, '.', ',');
      } else if (format.indexOf('amount_no_decimals') !== -1) {
        value = formatWithDelimiters(cents, 0, ',', '.');
      } else if (format.indexOf('amount_with_comma_separator') !== -1) {
        value = formatWithDelimiters(cents, 2, '.', ',');
      } else if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
        value = formatWithDelimiters(cents, 2, "'", '.');
      } else {
        value = formatWithDelimiters(cents, 2, ',', '.');
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/ /g, '\u00A0');
    };

    function getUnitPriceCents() {
      return parseFloat(formWrapper.dataset.unitPriceCents) || 0;
    }

    function getDiscountRate() {
      if (formWrapper.dataset.b2b === 'true') return 0;
      return parseFloat(formWrapper.dataset.discountRate) || 15;
    }

    function updateAmount() {
      var qty = parseInt(qtyInput.value) || 1;
      var unitCents = getUnitPriceCents();
      var rate = getDiscountRate();
      var multiplier = rate / 100;

      if (countDisplay) countDisplay.textContent = qty;

      var totalPriceCents, savingsCents;
      if (qty >= 2) {
        totalPriceCents = qty * unitCents * (1 - multiplier);
        savingsCents = qty * unitCents * multiplier;
      } else {
        totalPriceCents = qty * unitCents;
        savingsCents = 0;
      }

      var perPortionCents;
      if (qty >= 2) {
        perPortionCents = unitCents * (1 - multiplier);
      } else {
        perPortionCents = unitCents;
      }

      var perUnitEl = formWrapper.querySelector('[data-price-per-unit-value]');
      if (perUnitEl) {
        var portions = parseInt(formWrapper.dataset.portions) || 0;
        if (portions > 0) {
          perUnitEl.textContent = formatMoney(perPortionCents / portions);
        } else {
          perUnitEl.textContent = formatMoney(perPortionCents);
        }
      }

      if (savingsEl) {
        if (qty >= 2 && savingsCents > 0) {
          savingsEl.hidden = false;
          if (savingsValueEl) savingsValueEl.textContent = formatMoney(savingsCents);
        } else {
          savingsEl.hidden = true;
        }
      }

      if (atcText && atcBtn && !atcBtn.hasAttribute('disabled')) {
        atcText.textContent = atcPrefix + ' ' + formatMoney(totalPriceCents);
      }

      tierBtns.forEach(function (btn) {
        var btnQty = parseInt(btn.dataset.qty);
        if (btnQty === qty) {
          btn.classList.add('bundle-btn--active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('bundle-btn--active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });

      if (decBtn) {
        if (qty <= 1) {
          decBtn.setAttribute('aria-disabled', 'true');
        } else {
          decBtn.removeAttribute('aria-disabled');
        }
      }
    }

    function selectTier(btn) {
      var qty = parseInt(btn.dataset.qty);
      if (qtyInput) qtyInput.value = qty;
      updateAmount();
    }

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectTier(btn);
      });
    });

    if (decBtn) {
      decBtn.addEventListener('click', function () {
        var qty = parseInt(qtyInput.value) || 1;
        if (qty > 1) {
          qtyInput.value = qty - 1;
          updateAmount();
        }
      });
    }

    if (incBtn) {
      incBtn.addEventListener('click', function () {
        var qty = parseInt(qtyInput.value) || 1;
        qtyInput.value = qty + 1;
        updateAmount();
      });
    }

    function updateFromVariant(event) {
      if (!event || !event.data || !event.data.variant) return;
      var variant = event.data.variant;
      if (!variant) return;

      var newVariantId = variant.id;
      var idInput = formWrapper.querySelector('input[name="id"]');
      if (idInput) idInput.value = newVariantId;

      var newUnitPriceCents = variant.price || 0;
      formWrapper.dataset.unitPriceCents = newUnitPriceCents;

      var rate = getDiscountRate();
      var multiplier = rate / 100;
      var newPrice2FullCents = newUnitPriceCents * 2;
      var newSaving2Cents = newUnitPriceCents * 2 * multiplier;
      var newPrice2DiscountedCents = newUnitPriceCents * 2 * (1 - multiplier);

      var tier1Price = formWrapper.querySelector('[data-tier-price="1"]');
      if (tier1Price) tier1Price.textContent = formatMoney(newUnitPriceCents);

      var tier2Price = formWrapper.querySelector('[data-tier-price="2"]');
      if (tier2Price) {
        tier2Price.innerHTML = formatMoney(newPrice2DiscountedCents) +
          ' <s class="bundle-old-price">' + formatMoney(newPrice2FullCents) + '</s>';
      }

      var tier2Saving = formWrapper.querySelector('[data-tier-saving="2"]');
      if (tier2Saving) tier2Saving.textContent = savingsPrefix + ' ' + formatMoney(newSaving2Cents);

      if (variant.available === false && atcBtn) {
        atcBtn.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = formWrapper.dataset.soldOut || atcText.textContent;
      } else if (atcBtn) {
        atcBtn.removeAttribute('disabled');
      }

      updateAmount();
    }

    formWrapper.dataset.unitPriceCents = formWrapper.dataset.unitPriceCents || '0';

    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(PUB_SUB_EVENTS.variantChange, updateFromVariant);
    } else {
      document.addEventListener('variant:change', updateFromVariant);
    }

    updateAmount();
  })();
